<template>
  <fleets />
</template>

<script>
import Fleets from "@/components/3pl/Fleets/index";
export default {
  components: {
    Fleets,
  },
};
</script>

<style></style>
